module.exports = __webpack_public_path__ + "img/55-r.b43dd39b.png";